/*
 * @Author: Teemo Ding
 * @Date: 2021-12-24 10:55:16
 * @LastEditTime: 2022-01-06 13:49:51
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/Components/ProductsItems/OrderRecordsTable.tsx
 */
import React from 'react';
//import { get, cloneDeep } from 'lodash';
//import { isNumber } from 'src/tools/helper';
import Link from '@/src/components/Link/Link';
import { get } from 'lodash';
import { SizeFittingTable } from 'src/components/Antd';
import { EnumTablePosition } from 'src/types/common/common';
//import ExclusiveCustom from '../ExclusiveCustom';
//import SkuItems from '../SkuItems';
//import { EditIcon } from '@/src/components/EditableTable/EditableTable';
//import { TableNumberInputWithSlash } from 'src/components/EditableTable/TableForm1';
import GlobalTooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';

import { useI18n } from '@/src/hooks/useRouterChange';
import { i18nGet } from '@/src/tools/tools';
import { formatTimeBySetting } from '@/src/tools/helper';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { getBasicSetting } from 'src/constrains/GlobalProvider/slice';
import css from './css.module.less';
import { statusText } from '../../config';
const widthDict = {
  orderId: { minWidth: 160 },
  orderTime: { minWidth: 173 },
  orderStatus: { minWidth: 108 },
  originalPrice: { minWidth: 100 },
  discount: { minWidth: 67 },
  paidPrice: {
    minWidth: 80,
  },
  action: { width: 67 },
};
const tableName = 'additionalItem';
const OrderRecordsTable = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const format = formatTimeBySetting(useSelector(getBasicSetting()));
  const {
    value, //onChange, nonOperational
  } = props;

  const columns = [
    {
      title: getI18n(
        'subscriptionBuy.subscriptionBuy.productItems_OrderRecordsTable_columns_orderid_title',
      ),
      key: 'orderId',
      default: true,
      sorter: (a, b) => {
        const name1 = a.orderNo || '';
        const name2 = b.orderNo || '';
        const n1 = name1.toLowerCase();
        const n2 = name2.toLowerCase();
        if (n1 > n2) return 1;
        if (n2 > n1) return -1;
        return 0;
      },
      childGenerate: (text, record) => {
        const { orderNo } = record;
        return (
          <NoWrapContainer>
            <GlobalTooltip title={orderNo || '-'}>{orderNo}</GlobalTooltip>
          </NoWrapContainer>
        );
      },
      ...widthDict['orderId'],
    },
    {
      title: getI18n(
        'subscriptionBuy.subscriptionBuy.productItems_OrderRecordsTable_columns_orderTime_title',
      ),
      key: 'orderTime',
      default: true,
      sorter: (a, b) => {
        const time1 = moment(
          get(a, 'createdDate', new Date()),
          format,
        ).valueOf();
        const time2 = moment(
          get(b, 'createdDate', new Date()),
          format,
        ).valueOf();
        return time1 > time2 ? 1 : -1;
      },
      childGenerate: (text, record) => {
        const { createdDate } = record;
        return (
          <NoWrapContainer>
            <GlobalTooltip title={createdDate || '-'}>
              {createdDate}
            </GlobalTooltip>
          </NoWrapContainer>
        );
      },
      ...widthDict['orderTime'],
    },

    {
      title: getI18n(
        'subscriptionBuy.subscriptionBuy.productItems_OrderRecordsTable_columns_orderStatus_title',
      ),
      key: 'Order Status',
      default: true,
      //optional: false,
      //  className: css.tableCol,
      // position: EnumTablePosition.right,
      childGenerate: (text, record) => {
        const { orderStatus } = record;
        return (
          <NoWrapContainer>
            <GlobalTooltip title={statusText[orderStatus] || '-'}>
              {statusText[orderStatus]}
            </GlobalTooltip>
          </NoWrapContainer>
        );
      },
      ...widthDict['orderStatus'],
    },
    {
      titleGenerate: () => (
        <div>
          {getI18n(
            'subscriptionBuy.subscriptionBuy.productItems_OrderRecordsTable_columns_originalPrice_title',
          )}
          (HKD)
        </div>
      ),
      key: 'originalPrice',
      default: true,
      position: EnumTablePosition.right,
      childGenerate: (_, record) => {
        const { originalPrice } = record;
        return (
          <NoWrapContainer>
            <GlobalTooltip title={originalPrice}>{originalPrice}</GlobalTooltip>
          </NoWrapContainer>
        );
      },
      ...widthDict['originalPrice'],
    },
    {
      titleGenerate: () => (
        <div>
          {getI18n(
            'subscriptionBuy.subscriptionBuy.productItems_OrderRecordsTable_columns_discount_title',
          )}
          (HKD)
        </div>
      ),
      key: 'Disc',
      default: true,
      position: EnumTablePosition.right,
      childGenerate: (text, record) => {
        const { discountPrice } = record;

        return (
          <NoWrapContainer>
            <GlobalTooltip title={`-${discountPrice}`}>
              {discountPrice ? `-${discountPrice}` : '-'}
            </GlobalTooltip>
          </NoWrapContainer>
        );
      },
      ...widthDict['discount'],
    },
    {
      titleGenerate: () => <div>{getI18n('general.paidPrice')}(HKD)</div>,
      key: 'paidPrice',
      default: true,
      position: EnumTablePosition.right,
      childGenerate: (text, record) => {
        const { totalPrice } = record;
        return (
          <NoWrapContainer className={css.paidPrice}>
            <GlobalTooltip title={totalPrice}>
              {totalPrice ? totalPrice : '-'}
            </GlobalTooltip>
          </NoWrapContainer>
        );
      },
      ...widthDict['paidPrice'],
    },
    {
      title: getI18n(
        'subscriptionBuy.subscriptionBuy.productItems_OrderRecordsTable_columns_action_title',
      ),
      dataIndex: 'action',
      default: true,
      key: 'action',
      align: 'center',
      className: css.columnClass,
      minWidth: 96,
      render: (text, record, index) => (
        <div className={css.viewAction}>
          <Link to={`/order/${record.uuid}`}>{getI18n('general.view')}</Link>
        </div>
      ),
      ...widthDict['action'],
    },
  ];

  return (
    <SizeFittingTable
      rowKey='uuid'
      pagination={false}
      dataSource={value}
      className={css.detailTable}
      id={tableName}
      columns={columns}
    />
  );
};

export default OrderRecordsTable;
